import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Divider,
  Button,
  Grid,
  CircularProgress,
} from '@material-ui/core';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { differenceInHours } from 'date-fns';
import { LatLng } from 'leaflet';
import { useStyles } from './styles';
import {
  Intervencao,
  Solicitacao,
  Projeto,
  Execucao,
  Envolvidos,
  EngineeringRequest,
  EngineeringResponse,
  Location,
  Analysis,
} from '../../@types/engineeringTypes';
import { generateId } from './utils';
import api from '../../services/api';
import EnginneringTopForm from '../../components/EngineeringTopForm';
import RequestForm from '../../components/RequestFormGroup';
import ProjectForm from '../../components/ProjectFormGroup';
import ExecutionForm from '../../components/ExecutionFormGroup';
import InvovedFormGroup from '../../components/InvolvedFormGroup';
import DialogWarningMessage from '../../components/DialogWarningMessage';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import DialogConfirm from '../../components/DialogConfirm';
import DialogWarnActions, { DialogActionType } from '../../components/DialogWarnActions';
import AnalysisForm from '../../components/AnalysisFormGroup';
import { deleteEngineeringById, fetchEngineeringById, updateEngineering } from '../../actions/engineeringActions';
import Colors from '../../components/Colors';

export interface Coordinates {
  lat: number;
  lng: number;
}

interface ParamsType {
  pathId: string;
}

const initialIntervention: Intervencao = {
  Tipo: 'Infraestrutura Cicloviária',
  Especificação: 'Ciclovia',
  Elemento: 'Ponto',
  _localId: generateId(),
};
const initialAnalysis: Analysis = {
  'Data de Analise': null,
  'Detalhes da Analise': '',
  'Nome do Analista': '',
};

const initialRequest: Solicitacao = {
  'Nome da Intervenção': '',
  'Data de Solicitação': null,
  'Nome do Solicitante': '',
  'Número do Protocolo': '',
  'Descrição da Intervenção': '',
  'Protocolo Informado': 'Não',
  _localId: generateId(),
};

const initialProject: Projeto = {
  'Projeto com mais de uma Intervenção': 'Não',
  Deferido: 'Não',
  'Projeto Dependente': 'Não',
  'Identificador do Projeto Dependente': '',
  'Identificador do Projeto': '',
  'Data de Elaboração do Projeto': null,
  Responsável: '',
  Status: '',
  _localId: generateId(),
};

const initialExecution: Execucao = {
  'Data de Envio': null,
  'Data de Início': null,
  'Data de Conclusão': null,
  'Data de Desativação': null,
  'Sem GEENG': 'Não',
  'Sem Projeto': 'Não',
  'Identificador da Execução da Intervenção': '',
  'Nome do Responsável pela Execução': '',
  _localId: generateId(),
};

const initialInvolved: Envolvidos = {
  'Data Dois Antes': null,
  'Data Dois Depois': null,
  'Data Um Antes': null,
  'Data Um Depois': null,
  _localId: '',
};

const initialPostObj: EngineeringRequest = {
  data: {
    driverEngineeringInterventionRequest: initialRequest,
    driverEnginneringAnalysis: initialAnalysis,
    driverEngineeringIntervention: initialIntervention,
    driverEngineeringInterventionProject: initialProject,
    driverEngineeringInterventionExecution: initialExecution,
    driverEngineeringInterventionInvolved: initialInvolved,
  },
  geom: '',
  occurred_from: '',
  occurred_to: '',
  schema: '',
  location_text: ''
};

const UpdateEngineering: React.FC = () => {
  const classes = useStyles();
  const [intervention, setItervention] = useState<Intervencao>(initialIntervention);
  const [request, setRequest] = useState<Solicitacao>(initialRequest);
  const [analysis, setAnalysis] = useState<Analysis>(initialAnalysis);
  const [project, setProject] = useState<Projeto>(initialProject);
  const [execution, setExecution] = useState<Execucao>(initialExecution);
  const [involved, setInvolved] = useState<Envolvidos>(initialInvolved);
  const [latlng, setLatLng] = useState<Coordinates>({ lat: 0, lng: 0 });
  const [polylines, setPolylines] = useState<Array<LatLng>>([]);
  const [period, setPeriod] = useState<{ occurred_from: string; occurred_to: string }>();
  const [warnMessages, setWarnMessages] = useState<{ key: string; message: string }[]>(
    [],
  );
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });
  const [loading, setLoading] = useState<boolean>(true);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openDialogConfirm, setDialogConfirm] = useState<boolean>(false);
  const [dialogAction, setDialogAction] = useState<DialogActionType>({
    open: false,
    title: '',
    actions: [],
  });
  const [reference, setReference] = useState<string>('');
  const [intersection, setIntersection] = useState<'Sim' | 'Não' | 'Não informado'>(
    'Não informado',
  );
  const [adresses, setAdresses] = useState<{
    address1: string;
    address2: string;
    neighborhood: string;
  }>({
    address1: '',
    address2: '',
    neighborhood: '',
  });

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const formRef = useRef<FormHandles>(null);

  const { pathId } = useParams<ParamsType>();

  const history = useHistory();
  const navigate = (path: string) => {
    history.push(path);
  };
  const postRecord = async (record: EngineeringRequest) => {
    setLoading(true);
    try {
      const { data } = await updateEngineering(pathId, record);
      mountStates(data);
      setWarnMessages([]);

      setDialogAction({
        open: true,
        title: 'Intervenção de Engenharia atualizada com sucesso!',
        actions: [
          {
            btnText: 'Registros',
            color: 'primary',
            action: () => navigate('/registros/engenharias'),
          },
          {
            btnText: 'Mapa',
            color: 'primary',
            action: () => navigate('/mapa/engenharias'),
          },
          {
            btnText: 'Exibir',
            color: 'primary',
            action: () => navigate(`/registro/engenharia/${pathId}`),
          },
        ],
      });
    } catch (error) {
      setSnackbar({ open: true, message: 'Erro ao adicionar Intervenção de Engenharia' });
    } finally {
      setLoading(false);
    }
  };

  const deleteRecord = async (id: string) => {
    setLoading(true);
    try {
      await deleteEngineeringById(id);
      
      setDialogAction({
        open: true,
        title: 'Intervenção de Engenharia removida com sucesso!',
        actions: [
          {
            btnText: 'Registros',
            color: 'primary',
            action: () => navigate('/registros/engenharias'),
          },
          {
            btnText: 'Mapa',
            color: 'primary',
            action: () => navigate('/mapa/engenharias'),
          },
          {
            btnText: 'Nova Intervenção',
            color: 'primary',
            action: () => navigate('/add/engenharia'),
          },
        ],
      });
    } catch (error) {
      setSnackbar({ open: true, message: 'Erro ao excluir a intervenção de engenharia' });
    } finally {
      setLoading(false);
    }
  };

  const validateFields = (fieldsData: EngineeringRequest) => {
    const { data } = fieldsData;
    setWarnMessages([]);
    const formError: { key: string; message: string }[] = [];

    if (latlng.lat === 0 || latlng.lng === 0) {
      formError.push({
        key: 'location',
        message: 'Informe a localização da intervenção.',
      });
    }

    if (data.driverEngineeringLocation?.['Endereço 1'] === '') {
      formError.push({
        key: 'address1',
        message: 'Informe o endereço 1.',
      });
    }

    if (
      data.driverEngineeringLocation?.Cruzamento === 'Sim' &&
      data.driverEngineeringLocation['Endereço 2'] === ''
    ) {
      formError.push({
        key: 'address2',
        message: 'Informe o endereço 2.',
      });
    }

    const deferido = data.driverEngineeringInterventionProject.Deferido;

    const dataSolicitação =
      data.driverEngineeringInterventionRequest['Data de Solicitação'];
    const dataAnalise = data.driverEnginneringAnalysis['Data de Analise'];

    const dataEnvio = data.driverEngineeringInterventionExecution['Data de Envio'];
    const dataElaboracao =
      data.driverEngineeringInterventionProject['Data de Elaboração do Projeto'];
    const dataInicio = data.driverEngineeringInterventionExecution['Data de Início'];
    const dataConclusao =
      data.driverEngineeringInterventionExecution['Data de Conclusão'];
    const dataDesativacao =
      data.driverEngineeringInterventionExecution['Data de Desativação'];

    if (
      !dataSolicitação &&
      !dataElaboracao &&
      !dataEnvio &&
      !dataInicio &&
      !dataConclusao
    ) {
      formError.push({
        key: 'dataProjeto',
        message:
          'Pelo menos uma data (entre solicitação e conclusão) deve ser informada.',
      });
    } else {
      let status:
        | 'Solicitado'
        | 'Em analise'
        | 'Aguardando projeto'
        | 'Em projeto'
        | 'Projetado'
        | 'Aguardando execução'
        | 'Em execução'
        | 'Concluído'
        | 'Desativado'
        | 'Indeferido' = 'Solicitado';

      if (dataAnalise) {
        status = 'Em analise';
        if (dataAnalise && deferido === 'Sim') {
          status =
            data.driverEngineeringInterventionProject['Identificador do Projeto'] !== ''
              ? 'Em projeto'
              : data.driverEngineeringInterventionProject.Responsável !== ''
              ? 'Em projeto'
              : 'Aguardando projeto';
        } else if (dataAnalise && deferido === 'Não') {
          status = 'Indeferido';
        }
        if (
          dataSolicitação &&
          differenceInHours(new Date(dataAnalise), new Date(dataSolicitação)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-anl',
            message: 'A data de analise não pode ser antes da data de solicitação.',
          });
        }
      }

      if (dataElaboracao) {
        status = 'Projetado';
        if (
          dataAnalise &&
          differenceInHours(new Date(dataElaboracao), new Date(dataAnalise)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-el',
            message: 'A data de elaboração não pode ser antes da data de analise',
          });
        }
      }

      if (dataEnvio) {
        status = 'Aguardando execução';
        if (
          dataElaboracao &&
          differenceInHours(new Date(dataEnvio), new Date(dataElaboracao)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-req',
            message: 'A data de envio não pode ser antes da data de elaboração.',
          });
        }
      }

      if (dataInicio) {
        status = 'Em execução';
        if (
          dataElaboracao &&
          differenceInHours(new Date(dataInicio), new Date(dataElaboracao)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-init',
            message:
              'A data de início não pode ser antes da data de elaboração do projeto',
          });
        }
      }

      if (dataConclusao) {
        status = 'Concluído';
        if (
          dataInicio &&
          differenceInHours(new Date(dataConclusao), new Date(dataInicio)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-finish',
            message:
              'A data de conclusão não pode ser antes da data de início do projeto',
          });
        }
      }

      if (dataDesativacao) {
        status = 'Desativado';
        if (
          dataConclusao &&
          differenceInHours(new Date(dataDesativacao), new Date(dataConclusao)) < 0
        ) {
          formError.push({
            key: 'dataProjeto-desable',
            message:
              'A data de desativação não pode ser antes da data de conclusão do projeto',
          });
        }
      }

      fieldsData.data.driverEngineeringInterventionProject.Status = status;
    }

    if (
      data.driverEngineeringIntervention.Tipo.length === 0 ||
      !data.driverEngineeringIntervention.Tipo.trim()
    ) {
      formError.push({
        key: 'tipoIntervencao',
        message: 'A missão de Engenharia precisa de um tipo válido a ser cadastrado',
      });
    }

    if (formError.length === 0) {
      postRecord(fieldsData);
      return;
    }

    setWarnMessages(formError);
    setOpenDialog(true);
  };

  const handleSubmit = () => {
    const bodyForm: EngineeringRequest = initialPostObj;
    const exec = { ...execution };
    const proj = { ...project };
    const req = { ...request };
    const inv = { ...involved };
    const location: Location = {
      'Endereço 1': adresses.address1,
      'Endereço 2': adresses.address2,
      Cruzamento: intersection,
      'Numero Referencia': reference,
    };
    if (!exec['Data de Conclusão']) exec['Data de Conclusão'] = '';
    if (!exec['Data de Desativação']) exec['Data de Desativação'] = '';
    if (!exec['Data de Envio']) exec['Data de Envio'] = '';
    if (!exec['Data de Início']) exec['Data de Início'] = '';

    if (!proj['Data de Elaboração do Projeto']) {
      proj['Data de Elaboração do Projeto'] = '';
    }

    if (!req['Data de Solicitação']) req['Data de Solicitação'] = '';

    if (!inv['Data Um Antes']) inv['Data Um Antes'] = '';
    if (!inv['Data Um Depois']) inv['Data Um Depois'] = '';
    if (!inv['Data Dois Antes']) inv['Data Dois Antes'] = '';
    if (!inv['Data Dois Depois']) inv['Data Dois Depois'] = '';

    bodyForm.occurred_from = period ? period.occurred_from : new Date().toISOString();
    bodyForm.occurred_to = new Date().toISOString();
    bodyForm.data.driverEngineeringIntervention = intervention;
    bodyForm.data.driverEngineeringInterventionRequest = req;
    bodyForm.data.driverEngineeringInterventionProject = proj;
    bodyForm.data.driverEngineeringInterventionExecution = exec;
    bodyForm.data.driverEngineeringInterventionInvolved = inv;
    bodyForm.data.driverEngineeringLocation = location;

    if (intervention.Elemento === 'Ponto') {
      bodyForm.geom = `POINT(${latlng.lng} ${latlng.lat})`;
      bodyForm.schema = `${process.env.REACT_APP_ENGINEERING_SCHEMA_ID}`;
    } else {
      let linestring = '';

      polylines.forEach((loc) => {
        linestring += `${loc.lat} ${loc.lng},`;
      });

      bodyForm.geom = `LINESTRING(${linestring.slice(0, -1)})`;
      bodyForm.schema = `${process.env.REACT_APP_ENGINEERING_LINE_SCHEMA_ID}`;
    }
    validateFields(bodyForm);
  };

  const mountStates = (data: EngineeringResponse) => {
    const location: Location = data.data.driverEngineeringLocation
      ? data.data.driverEngineeringLocation
      : {
          'Endereço 1': '',
          'Endereço 2': '',
          Cruzamento: 'Não informado',
          'Numero Referencia': '',
        };

    if (data.geom.type === 'Point') {
      setLatLng({
        lng: data.geom.coordinates[0],
        lat: data.geom.coordinates[1],
      });
    } else {
      const lines: Array<LatLng> = [];

      data.geom.coordinates.forEach((coordinate: any) => {
        lines.push(new LatLng(coordinate[0], coordinate[1]));
      });

      setPolylines(lines);
    }

    setItervention(data.data.driverEngineeringIntervention);
    setRequest(data.data.driverEngineeringInterventionRequest);
    setProject(data.data.driverEngineeringInterventionProject);
    setExecution(data.data.driverEngineeringInterventionExecution);
    setInvolved(data.data.driverEngineeringInterventionInvolved);
    setPeriod({ occurred_from: data.occurred_from, occurred_to: data.occurred_to });
    setAdresses({
      address1: location['Endereço 1'],
      address2: location['Endereço 2'],
      neighborhood: '',
    });
    setIntersection(location.Cruzamento);
    setReference(location['Numero Referencia'] ? location['Numero Referencia'] : '');
  };

  useEffect(() => {

    async function fetchEngineering(id: string) {
      setLoading(true);
      try {
        const { data } = await fetchEngineeringById(id);
        mountStates(data);

      } catch (error) {
        console.log(error);
        setDialogAction({
          open: true,
          title: 'Não foi possível encontrar a intervenção de engenharia',
          actions: [
            {
              btnText: 'Registros',
              color: 'primary',
              action: () => navigate('/registros/engenharias'),
            },
            {
              btnText: 'Mapa',
              color: 'primary',
              action: () => navigate('/mapa/engenharias'),
            },
            {
              btnText: 'Nova Intervenção',
              color: 'primary',
              action: () => navigate('/add/engenharia'),
            },
          ],
        });
      } finally {
        setLoading(false);
      }
    }

    fetchEngineering(pathId);
  }, [pathId, authHeader]);
  return (
    <Container className={classes.root}>
      <Typography variant="h5">Internvenções de Engenharia</Typography>
      <Divider />
      <Form
        className={classes.formGroup}
        autoComplete="off"
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <Grid container>
          <Grid container xs={12} md={10}>
            <Grid item xs={12}>
              <EnginneringTopForm
                intervention={intervention}
                setIntervention={setItervention}
                latlng={latlng}
                setLatLng={setLatLng}
                polylines={polylines}
                setPolylines={setPolylines}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
                setAdresses={setAdresses}
                adresses={adresses}
                setIntersection={setIntersection}
                intersection={intersection}
                setReference={setReference}
                reference={reference}
              />
            </Grid>
            <Grid item xs={12}>
              <RequestForm
                request={request}
                setRequest={setRequest}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12}>
              <AnalysisForm
                analysis={analysis}
                setAnalysis={setAnalysis}
                project={project}
                setProject={setProject}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12}>
              <ProjectForm
                project={project}
                setProject={setProject}
                minDate={
                  execution['Data de Envio'] || request['Data de Solicitação'] || ''
                }
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12}>
              <ExecutionForm
                execution={execution}
                setExecution={setExecution}
                minSendDate={request['Data de Solicitação'] || ''}
                minStartDate={project['Data de Elaboração do Projeto'] || ''}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12}>
              <InvovedFormGroup involved={involved} setInvolved={setInvolved} />
            </Grid>
          </Grid>
          <Grid>
            <div className={classes.buttonsContainer}>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  style={{ backgroundColor: Colors.secundary }}
                >
                  Atualizar Engenharia
                </Button>
                {loading && (
                  <CircularProgress size={24} className={classes.buttonProgress} />
                )}
              </div>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  color="default"
                  onClick={() => setDialogConfirm(true)}
                  disabled={loading}
                  style={{ backgroundColor: '#C59054', color: 'white' }}
                >
                  Excluir Engenharia
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    color="secondary"
                    className={classes.buttonProgress}
                  />
                )}
              </div>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate('/mapa/engenharias')}
                  disabled={loading}
                  style={{ backgroundColor: 'white' }}
                >
                  Cancelar
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    color="secondary"
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </Form>
      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
      <DialogWarningMessage
        title="Algumas informações precisam de atenção."
        messages={warnMessages}
        open={openDialog}
        setOpen={setOpenDialog}
      />
      <DialogConfirm
        open={openDialogConfirm}
        title="Apagar Intervenção de Engenharia?"
        message="Voce está prestes a apagar essa intervenção de engenharia. Ao confirmar, essa operação não poderá ser desfeita. Você deseja confirmar essa ação?"
        setOpen={setDialogConfirm}
        onConfirm={() => deleteRecord(pathId)}
      />
      <DialogWarnActions dialogActions={dialogAction} setDialog={setDialogAction} />
    </Container>
  );
};

export default UpdateEngineering;
